import { IS_EMBEDDED } from 'utils/queryParamHelpers';

export default function updateSuccessPageUrl(email, token, userId) {
  // If the user is coming from the mobile app, we need to add some special
  // values to the native app before sending the user to the
  // success page, because the mobile app uses these values to login the user.
  // We also only attempt to post if the app is accepting a post.
  if (IS_EMBEDDED && typeof window.ReactNativeWebView !== 'undefined') {
    window.postMessage(
      JSON.stringify({
        email,
        token,
        userId,
      })
    );
  } else {
    // If the user is in web, clear out QSPs, because for Marketing tools, the success
    // page for web needs to have the same URL every time. https://stackoverflow.com/a/41061471
    const urlWithoutQsps = window.location.pathname + window.location.hash;

    // https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState
    window.history.replaceState(null, '', urlWithoutQsps);
  }
}
